module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list disk-share-records"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("网盘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("分享记录")])], 1)], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.list,
      "loading": _vm.loading,
      "no-data-text": "还没有分享记录"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "详细记录",
      "width": "720"
    },
    model: {
      value: (_vm.showLog),
      callback: function($$v) {
        _vm.showLog = $$v
      },
      expression: "showLog"
    }
  }, [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.logColumns,
      "data": _vm.logList,
      "loading": _vm.logLoading,
      "no-data-text": "还没有预览或下载"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da1a87c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/disk/DiskShareRecords.vue
// module id = 1968
// module chunks = 8